Apt.fn.extend('filters', {
	/**
	 * Compile data into structured endpoint
	 *
	 * @param {String} [base]
	 * @param {Object} [data]
	 * @param {Number} [page]
	 * @returns {String}
	 */
	build: function(base, data, page) {
		var scope = this,
			path = base;

		if (data) {
			var filters = [];

			data = $.unserialize(
				$.serialize(data)
			);

			if (base === null) {
				path = Apt.filters.root();
			}

			Object.keys(data).forEach(function(key) {
				var val = data[key];

				if (val) {
					if (key === 'location') {
						path += '/' + val;
					} else {
						if (Array.isArray(val)) {
							val = val.join('+');
						} else if (key.indexOf('[') > -1) {
							val = scope.parseNumber(val);
						} else {
							val = typeof val === 'string' ?
								val.replace(/ /g, '+') : val;
						}

						filters.push(key + '=' + val);
					}
				}
			});

			if (base === false) {
				path = '';
			}

			if (filters.length) {
				path += '/filter/' + filters.sort()
					.join(',')
					.replace(/\[]/g, '');
			}

			if (page && page > 1) {
				path += '/p' + page;
			}
		}

		return path;
	},

	/**
	 * Parse filter string into object
	 *
	 * @param {String} [criteria]
	 * @param {Boolean} [filter=true] - remove empty values
	 * @returns {Object}
	 */
	parse: function(criteria, filter) {
		criteria = criteria || '';
		var scope = this,
			params = scope.unserialize(criteria),
			data = {};

		Object.keys(params).forEach(function(key) {
			var parts = key.split('['),
				value = params[key];

			if (! filter || (filter && value)) {
				if (parts.length === 1) {
					data[key] = value;
					return;
				}

				var sub = parts[1].slice(0, -1);
				key = parts[0];
				value = scope.parseNumber(value);

				if (! sub) {
					data[key] = value;
				} else {
					if (! data[key]) {
						data[key] = {};
					}

					data[key][sub] = value;
				}
			}
		});

		if (Array.isArray(data.sort)) {
			data.sort = data.sort.join('+');
		}

		return data;
	},

	/**
	 * Get pagination index
	 *
	 * @param {String} [path]
	 * @returns {String}
	 */
	index: function(path) {
		return (path || $.routes.uri().path).replace(/\/p\d+$/, '');
	},

	/**
	 * Get base path of current request
	 *
	 * @returns {String}
	 */
	root: function() {
		var segs = $.routes.segments(),
			path = '/';

		if (segs.length) {
			if (segs.length > 1) {
				var index = segs.indexOf('filter');

				if (index > 0) {
					segs = segs.slice(0, index);
				} else if (/p\d+/.test(segs.slice(-1)[0])) {
					segs = segs.slice(0, -1);
				}
			}

			path += segs.join('/');
		}

		return path;
	},

	/**
	 * Parse URL filter data
	 *
	 * @returns {Object}
	 */
	get: function() {
		var scope = this,
			filters = scope.segment(),
			data = {};

		if (filters) {
			data = $.extend(data, scope.parse(filters));
		}

		return data;
	},

	/**
	 * Get filter segment from URL
	 *
	 * @returns {String}
	 */
	segment: function() {
		var segs = $.routes.segments();

		if (segs.length > 1) {
			var index = segs.indexOf('filter');

			if (index > 0) {
				return segs[index + 1];
			}
		}

		return '';
	},

	/**
	 * Parse filter string into query parameters
	 *
	 * @param {String} str
	 * @returns {Object}
	 */
	unserialize: function(str) {
		var data = $.unserialize(
			str.replace(/,/g, '&')
		);

		Object.keys(data).forEach(function(key) {
			if (key !== 'keywords') {
				var val = data[key];

				if (val.indexOf(' ') > -1) {
					data[key] = val.split(' ');
				}
			}
		});

		return data;
	},

	/**
	 * Get base page title
	 *
	 * @returns {String}
	 */
	title: function() {
		return $._doc.title.replace(/( – Page \d+)? – California Faucets/i, '');
	},

	/**
	 * Parse value into number
	 *
	 * @param {String} value
	 * @returns {*}
	 */
	parseNumber: function(value) {
		if (value && typeof value === 'string') {
			return parseFloat(
				value.replace(/[^\d.]/g, '')
			);
		}

		return value;
	}
});